module.exports = __webpack_public_path__ + "img/erp_case8.e220c1d8.jpg";